// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { colors } from '@teamnine/pcj-ui-v2'
import styled from 'styled-components'

export const Wrapper = styled.button`
  display: inline-flex;
  align-items: center;
  text-align: left;
  gap: 4px;
  cursor: pointer;
  text-decoration: underline;
  background: none;
  border: none;
  padding: 0;
  font: inherit;

  &:focus-visible {
    outline: 2px solid ${colors.ngprimary950};
    outline-offset: 2px;
    border-radius: 2px;
  }

  &:disabled {
    cursor: not-allowed;
  }
`
